import styled from 'styled-components';
import newLandingBackround from '../../../../static/assets/img/new-landing-background.svg';

export const HomeLifeCycleWrapper = styled.div`
  background-image: url(${newLandingBackround});
  background-size: cover;
  height: 100vh;
`;
